module.exports = __webpack_public_path__ + "static/img/bg.fc75217.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/choujiang/images/bg.jpg
// module id = +2GE
// module chunks = 169